<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-layout row wrap>
      <v-flex xs12 sm12 lg1>
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedInicio"
              label="Data Inicio"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedInicio)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataInicio" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaInicio"
          label="Hora Início"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              light
              v-model="dateFormattedFim"
              label="Data Fim"
              persistent-hint
              append-icon="event"
              @blur="date = parseDate(dateFormattedFim)"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="dataFim" no-title @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-text-field
          v-model="horaFim"
          label="Hora Fim"
          light
          type="time"
          outlined
          dense
        ></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 lg2>
        <v-select
          v-model="formaPagamento"
          :items="formasDePagamento"
          label="Forma de pagamento"
          multiple
          attach
          outlined
          dense
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 lg3>
        <v-select
          v-model="atendente"
          :items="atendentes"
          item-text="nome"
          item-value="id"
          label="Atendente"
          multiple
          outlined
          dense
        ></v-select>
      </v-flex>
      <v-flex xs12 sm12 lg1>
        <v-btn dark @click="carregaTransacoes" fab small color="#01579B"><v-icon>search</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-row>
      <v-col ls="12" sm="12" md="12" lg="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          class="elevation-1"
          style="border-radius: 10px;"
          :loading="tabela.carregamento"
          loading-text="Aguarde, buscando transações..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">RECARGAS</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="tabela.busca"
                append-icon="search"
                label="Pesquisa"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template slot="no-data">
            <v-row>
              <v-col>
                <v-alert style="margin-top: 16px" dark dense text outlined :value="true" color="warning" icon="info">Nenhuma recarga encontrada</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="no-results">
            <v-row>
              <v-col>
                <v-alert style="margin-top: 16px" dark dense text outlined :value="true" color="warning" icon="info">Sua pesquisa por "{{tabela.busca}}" não trouxe resultados</v-alert>
              </v-col>
            </v-row>
          </template>
          <template slot="body.append">
            <tr>
              <td :colspan="tabela.cabecalho.length">
                <h2 style="margin: 0 auto; text-align: center">Total: {{ campoSoma('valor').toString().replace('.',',') }}</h2>
              </td>
            </tr>
          </template>
          <template v-slot:[`item.valor`]="{ item }">
            R$ {{ item.valor }}
          </template>
          <template v-slot:[`item.created`]="{ item }">
            {{ formatDate(item.created.substring(0, 10)) }} às {{ item.created.substring(item.created.length - 5, 11) }}
          </template>
          <template v-slot:[`item.atendente.nome?`]="{ item }">
            {{ item.atendente == undefined ? 'Online' : item.atendente.nome}}
          </template>
          <template v-slot:[`item.statusPagamento`]="{ item }">
            <v-chip :color="item.statusPagamento == 'PAGO' || item.statusPagamento === undefined ? 'success' : 'warning'">
              {{ item.statusPagamento || 'PAGO' }}
            </v-chip>
          </template>
          <template v-slot:[`item.formaTransacao`]="{ item }">
            {{ item.formaTransacao === undefined || item.formaTransacao === '' ? 'ESPÉCIE' : item.formaTransacao }}
          </template>
          <template v-slot:[`item.consumidor.nome`]="{ item }">
            {{ item.consumidor && item.consumidor.nome ? item.consumidor.nome : 'Consumidor removido' }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom v-if="user.tipo === 'ADMIN'">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon @click="deleteItem(item)" color="#FF0000">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Excluir</span>
          </v-tooltip>
          </template>
        </v-data-table>
        <template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab v-on="on" dark @click="generatePDF" color="primary">
                  <v-icon large>arrow_circle_down</v-icon>
                </v-btn>
              </template>
              <span>Gerar PDF</span>
            </v-tooltip>
        </template>
      </v-col>
    </v-row>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';
  if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }
  export default {
    components: {Snackbar,},
    data: vm => ({
      date: new Date().toISOString().substr(0, 10),
      mask:"##:##:##",
      menu: false,
      configAccess: false,
      tabela: {
        cabecalho: [
          { text: 'Consumidor', value: 'consumidor.nome' },
          { text: 'Valor', value: 'valor' },
          { text: 'Forma de Pagamento', value: 'formaTransacao', },
          { text: 'Status', value: 'statusPagamento', },
          { text: 'Atendente', value: 'atendente.nome?' },
          { text: 'Tipo de Transação', value: 'tipoTransacao' },
          { text: 'Realizado em', value: 'created' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' }
        ],
        conteudo: [],
        busca: '',
        carregamento: false,
      },
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dateFormattedFim: vm.formatDate(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      horaInicio: '00:00',
      horaFim: '23:59',
      editedIndexCat: -1,
      editedIndexProd: -1,
      formaPagamento: ['TODOS'],
      formasDePagamento: ['CARTÃO','ESPÉCIE','PIX','TODOS'],
      eventos: [],
      atendente: '',
      atendentes: [],
      eventoId: '',
      eventoIdAtual: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitleProd () {
        return this.editedIndexProd === -1 ? 'ADICIONAR NOVO PRODUTO' : 'EDITAR PRODUTO'
      },
      computedDateFormattedInicio () {
        return this.formatDate(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatDate(this.dataFim)
      },
    }),

    watch: {
      configAccess (val) {
        if (val == true)
          this.openDialog()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatDate(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatDate(this.dataFim)
      },
    },

    mounted () {
      if (this.user.tipo == 'ADMIN') {
        this.tabela.cabecalho =  [
          { text: 'Consumidor', value: 'consumidor.nome' },
          { text: 'Valor', value: 'valor' },
          { text: 'Forma de Pagamento', value: 'formaTransacao', },
          { text: 'Status', value: 'statusPagamento', },
          { text: 'Atendente', value: 'atendente.nome?' },
          { text: 'Tipo de Transação', value: 'tipoTransacao' },
          { text: 'Realizado em', value: 'created' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' }
        ]
      }
      else{
        this.tabela.cabecalho =  [
          { text: 'Consumidor', value: 'consumidor.nome' },
          { text: 'Valor', value: 'valor' },
          { text: 'Forma de Pagamento', value: 'formaTransacao', },
          { text: 'Status', value: 'statusPagamento', },
          { text: 'Atendente', value: 'atendente.nome?' },
          { text: 'Tipo de Transação', value: 'tipoTransacao' },
          { text: 'Realizado em', value: 'created' },
        ]
      }
      this.carregaTransacoes()
      this.carregaUsuarios()

    },

    methods: {
      async carregaTransacoes() {
        this.tabela.carregamento = true;
        this.tabela.conteudo = [];

        // Construção básica do filtro
        let filtro = {
          "where": {
            "and": [
              {"created": {"gt": `${this.dataInicio}T${this.horaInicio}:00.000Z`}},
              {"created": {"lt": `${this.dataFim}T${this.horaFim}:59.999Z`}},
              {"empresaId": this.user.empresaId},
            ]
          },
          "include": ["consumidor", "atendente"]
        };
        // Se this.atendente não estiver em branco, adicione ao filtro
        if (this.atendente.length > 0) {
            // Se for uma array, pegue o primeiro elemento, senão use o valor como está.
            const atendenteValue = Array.isArray(this.atendente) ? this.atendente[0] : this.atendente;
            //let idsFormatados = Array.isArray(this.atendente) ? this.atendente.map(id => `"${id}`).join(',') : this.atendente;
            filtro.where.and.push({"atendenteId": atendenteValue});
        }

        // Filtro por tipo de transação
        const tiposTransacao = ['DEPÓSITO', 'SAQUE', 'ABERTURA_CAIXA', 'SANGRIA_CAIXA'];
        const orTipoTransacao = tiposTransacao.map(tipo => ({ "tipoTransacao": tipo }));
        filtro.where.and.push({ "or": orTipoTransacao });

        // Se formasDePagamento tiver itens, adicione a cláusula 'or' ao filtro
        if (this.formaPagamento.length > 0) {
            const orClause = this.formaPagamento.map(forma => ({ "formaTransacao": forma.toString() }));

            // Se 'TODAS' estiver selecionado, adicione a condição para incluir registros onde formaTransacao é undefined.
            if (this.formaPagamento.includes('TODOS')) {
                orClause.push({ "formaTransacao": undefined });
            }

            filtro.where.and.push({ "or": orClause });
        }

        // Converta o filtro para uma string e faça a chamada da API
        const filtroString = JSON.stringify(filtro);
        try {
          const response = await axios.get(`${baseApiUrl}ExtratoCartoes?filter=${filtroString}&access_token=${sessionStorage.getItem('accToken')}`);
          this.tabela.conteudo = response.data;
        } catch (error) {
          /* console.error("Erro ao carregar transações:", error); */
        } finally {
          this.tabela.carregamento = false;
        }
      },

      async carregaUsuarios(){
        await axios.get(baseApiUrl + 'Usuarios?filter={"where":{"and":[{"tipo":"CAIXA"},{"empresaId":"' + this.user.empresaId + '"}]}}&access_token=' + sessionStorage.getItem('accToken'))
          .then(response => {
            if (response.data) {
              this.atendentes = response.data
              this.atendentes.push({
                "id": "",
                "nome": "Online"
              })
              this.atendente = []
            }
          })
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHour(data_hora) {
        let data = data_hora.substr(0, 10).split('-')
        data = data[2] + '/' + data[1] + '/' + data[0]
        let hora = data_hora.substr(11, 8)

        return data + ' ' + hora
      },

      async deleteItem(item) {
        var r = confirm('Deseja EXCLUIR o extrato com o valor de: ' + item.valor + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'ExtratoCartoes/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "INFORMAÇÃO")
            this.carregaTransacoes()
          })
        }
      },


      campoSoma(key) {
          const totalCents = this.tabela.conteudo.reduce((a, b) => {
              // Convert the string "10,12" to a number 1012 (in cents)
              const valueString = (b[key] || "0").replace(',', '');
              const valueCents = parseInt(valueString, 10);

              switch(b.tipoTransacao) {
                  case "SAQUE":
                  case "SANGRIA_CAIXA":
                      return a - valueCents;
                  case "DEPÓSITO":
                    switch (b.formaTransacao) {
                        case 'ESPÉCIE':
                        case 'CARTÃO':
                          return a + valueCents;
                        case 'PIX':
                          switch (b.statusPagamento) {
                            case 'PAGO':
                            case undefined:
                              return a + valueCents;  // Adicionar para espécie
                            default:
                                return a;
                          }
                        default:
                          return a;
                      }
                  case "ABERTURA_CAIXA":
                      return a + valueCents;
                  default:
                      return a; // If the transaction type is neither of the three, just return the accumulated value
              }
          }, 0);

          // Convert back from cents to the format 10,12 and then to the desired string format
          const result = (totalCents / 100).toFixed(2).replace('.', ',');
          return 'R$ ' + result;
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      compare(a) {
        // Use toUpperCase() to ignore character casing
        const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
        //const dataB = new Date(moment(this.formatDatePadrao(b.fim)).format('YYYY-MM-DDTHH:mm:ss.000Z').replace('-03:00', 'Z'))
        const dataC = moment().format()

        let comparison = 0;
        if (dataC >= dataA)
          comparison = 1;
        /* else if (dataA >= dataC && dataB < dataA)
          comparison = -1; */
        else if (dataC < dataA)
          comparison = -1;
        return comparison;
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      getFirstAndLastName(fullName) {
          const nameParts = fullName.trim().split(/\s+/); // Split pelo espaço e remove espaços extras
          if (nameParts.length === 1) {
            return fullName; // Se tiver apenas um nome, retorna ele
          }
          return `${nameParts[0]} ${nameParts[nameParts.length - 1]}`; // Retorna o primeiro e o último nome
        },

      generatePDF(){
        const docDefinition = {
            content: [
            { text: `Relatório de Transações - (${this.formatDate(this.dataInicio)} - ${this.horaInicio} à ${this.formatDate(this.dataFim)} - ${this.horaFim})`, style: 'header' },
              { text: `Valor Total no Período: ${this.campoSoma('valor').toString().replace('.',',')}`, style: 'transactionHeader' },
              {
                style: 'transactionsTable',
                table: {
                  headerRows: 1,
                  widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
                  body: [
                    // Cabeçalhos da tabela
                    [
                      { text: 'Tipo de Transação', style: 'tableHeader' },
                      { text: 'Valor', style: 'tableHeader' },
                      { text: 'Forma de Pagamento', style: 'tableHeader' },
                      { text: 'Status', style: 'tableHeader' },
                      { text: 'Consumidor', style: 'tableHeader' },
                      { text: 'Atendente', style: 'tableHeader' },
                      {text: 'Data',style: 'tableHeader'}
                    ],
                    // Dados das transações
                    ...this.tabela.conteudo.map(t => [
                      t.tipoTransacao,
                      { text: t.valor, alignment: 'right' },
                      t.formaTransacao,
                      t.statusPagamento == undefined ? 'PAGO' : t.statusPagamento,
                      t.consumidor == undefined ? 'ABERTURA DE CAIXA' : this.getFirstAndLastName(t.consumidor.nome),
                      t.atendente == undefined ? 'Online' : t.atendente.nome,
                      this.formatDateHour(t.created)

                    ]),
                  ]
                },
                layout: 'lightHorizontalLines',
                }
            ],
            styles: {
              header: {
                fontSize: 16,
                bold: true,
                margin: [0, 0, 0, 10]
              },
              tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'black',
                margin: [0, 5, 0, 5]
              },
              transactionsTable: {
                margin: [0, 20, 0, 0]
              },
              transactionHeader: {
                  fontSize: 12,
                  bold: true,
                  margin: [0, 5, 0, 5]
              }
            },
            defaultStyle: {
              columnGap: 10
            }
          };

          pdfMake.createPdf(docDefinition).download(`Transacoes-${this.formatDate(this.dataInicio)}-${this.formatDate(this.dataFim)}.pdf`);
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
    font-size: 14px;
  }

  @import '../../node_modules/vue-anka-cropper/dist/VueAnkaCropper.css';
</style>
